import {ChargeSetupDto} from '@app/api/dmc';
import {DateCellComponent} from '@shared/components/table/cells/date-cell/date-cell.component';
import { Columns } from '@shared/interfaces/table/column-config';

const baseDetails: Columns<ChargeSetupDto>[] = [
  {
    title: 'chargeSetup.validFrom',
    key: 'validFrom',
    cellRenderer: DateCellComponent,
  },
  {
    title: 'chargeSetup.createdBy',
    key: 'createdBy',
  },
  {
    title: 'chargeSetup.created',
    key: 'created',
    cellRenderer: DateCellComponent,
  },
  {
    title: 'chargeSetup.modifiedBy',
    key: 'modifiedBy',
  },
  {
    title: 'chargeSetup.modified',
    key: 'modified',
    cellRenderer: DateCellComponent,
  },
];

export const chargeinformationChargesetupSinglePriceDetails: Columns<ChargeSetupDto>[] = [
  ...baseDetails,
  {
    title: 'chargeSetup.singlePrice',
    key: 'loadLevelNone',
  },
];

export const chargeinformationChargesetupDifferentiatedDetails: Columns<ChargeSetupDto>[] = [
  ...baseDetails,
  {
    title: 'chargeSetup.loadLevelLow',
    key: 'loadLevelLow',
  },
  {
    title: 'chargeSetup.loadLevelHigh',
    key: 'loadLevelHigh',
  },
  {
    title: 'chargeSetup.loadLevelPeak',
    key: 'loadLevelPeak',
  },
];
